import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = []
  initialize() {
    this.element['controller'] = this
  }
  connect() {
    this.input = this.element.querySelector(
      'input[type="text"], input[type="email"], input[type="number"], textarea'
    )
    this.label = this.element.querySelector('label')
    this.input?.addEventListener('focus', () => {
      this.label.classList.add('active')
    })
    this.input?.addEventListener('blur', () => {
      // this.label.classList.remove('active')
      this.label.classList[this.input.value ? 'add' : 'remove']('active')
    })
    this.input?.addEventListener('input', () => {
      console.log(this.input.value)
      this.input.classList[this.input.value ? 'add' : 'remove']('valid')
      this.input.classList[this.input.value ? 'add' : 'remove']('touched')
    })
    this.setInitialState()
  }
  setInitialState() {
    this.input?.classList[this.input?.value ? 'add' : 'remove']('valid')
    this.input?.classList[this.input?.value ? 'add' : 'remove']('touched')
    this.label?.classList[this.input?.value ? 'add' : 'remove']('active')
  }
}
